import React from "react";
import { DataTable } from "@/components/DataTable";
import { EmptyState } from "@/components/DataTable/States/Empty";
import { Calendar } from "lucide-react";
import { useTranslation } from "react-i18next";
import { useScheduledEventsColumns } from "./hooks/useScheduledEventsColumns";
import { ScheduledEventsTableHeader } from "./ScheduledEventsTableHeader";
import { useLiveEventsTable } from "./hooks/useLiveEventsTable";
import { LiveEventStatusEnum } from "@/__generated__/types";
import { useProtectedNavigation } from "@/routes/useProtectedNavigation";

export const ScheduledEventsTab = () => {
  const { t } = useTranslation();
  const { navToRoute } = useProtectedNavigation();
  const tableData = useLiveEventsTable(LiveEventStatusEnum.Scheduled);
  const {
    eventsData,
    loading,
    hasNextPage,
    hasPreviousPage,
    pageIndex,
    pageCount,
    handleFilterApply,
    getFilterDisplayValue,
    handleNextPage,
    handlePreviousPage,
    availableChatChannels,
  } = tableData;
  const columns = useScheduledEventsColumns();

  return (
    <DataTable
      data={eventsData}
      columns={columns}
      isLoading={loading}
      pagination={
        <>
          <DataTable.PaginationLabel
            pageCount={pageCount}
            pageIndex={pageIndex}
          />
          <DataTable.PaginationControls
            onNextPage={hasNextPage ? handleNextPage : false}
            onPreviousPage={hasPreviousPage ? handlePreviousPage : false}
          />
        </>
      }
      tableHeader={<DataTable.THeader />}
      tableBody={<DataTable.TBody />}
      emptyState={
        <EmptyState
          copy={t("gamesAndLiveEvents.table.scheduled.emptyState")}
          buttonCopy={t("gamesAndLiveEvents.table.scheduled.createNewEvent")}
          buttonTarget={() => navToRoute("editEvent")}
          icon={
            <Calendar
              className="h-[36px] w-[36px] text-primary-light"
              aria-label={t(
                "gamesAndLiveEvents.table.scheduled.createNewEvent",
              )}
            />
          }
        />
      }
      topHeader={
        <ScheduledEventsTableHeader
          onFilterChange={handleFilterApply}
          filterDisplayValue={getFilterDisplayValue()}
          availableChatChannels={availableChatChannels}
        />
      }
    />
  );
};
